'use strict';

function parse(reader) {
    reader.readUInt8('data.params.rule_index');
    reader.readUInt8('data.params.enable');
    reader.readUInt8('data.params.reserve'); // 保留位
    reader.readUInt32LE('data.params.event_source_or');
    reader.readUInt32LE('data.params.event_source_and');
    reader.readUInt32LE('data.params.event_destination');
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_1/common/rule/user-work-parser.js